import { QuestionCircleOutlined } from '@ant-design/icons'
import { Checkbox, Tooltip } from 'antd'

import cn from './UniformSlottedCheckbox.module.scss'

const TOOLTIP_TEXT =
  'Работает, если в фильтре выбраны значения только первого присоединения ' +
  '(например, 1/2" и/или 3/4"). Включение этой опции оставит в результатах ' +
  'только те товары, у которых все заполненные порты имеют один из этих ' +
  'размеров (например, 1/2" х 1/2" х 1/2" или 3/4" х 3/4" х 3/4"), либо ' +
  'остальные порты вовсе не заполнены (например, 1/2" х пусто х пусто). ' +
  'Переходные товары с разными размерами на разных портах (например, ' +
  '1/2" х 3/4") будут исключены из поиска.'

type UniformSlottedCheckboxProps = {
  checked: boolean
  disabled: boolean
  onChange: (checked: boolean) => void
}

function UniformSlottedCheckbox(props: UniformSlottedCheckboxProps) {
  const { checked, disabled, onChange } = props

  return (
    <span
      className={cn.uniformSlottedCheckbox}
      onClick={(event) => event.stopPropagation()}
    >
      <Checkbox
        checked={checked}
        disabled={disabled}
        onChange={(event) => onChange(event.target.checked)}
      >
        Только одинаковые порты
      </Checkbox>
      <Tooltip title={TOOLTIP_TEXT}>
        <QuestionCircleOutlined className={cn.uniformSlottedCheckboxIcon} />
      </Tooltip>
    </span>
  )
}

export default UniformSlottedCheckbox
